import Box from "@mui/material/Box";
import { memo, type PropsWithChildren } from "react";
import { DEFAULT_LAYOUT_CONTENT_ID, DEFAULT_LAYOUT_ID } from "../../../../constants/layouts/default-layout.const";
import useLayoutStylesStore from "../../../../hooks/layout/use-layout-styles-store/useLayoutStylesStore";
import useShowLayoutComponentsStore from "../../../../hooks/layout/use-show-layout-components-store/useShowLayoutComponentsStore";
import { Chatbot } from "../../../../legacy/components/Chatbot/chatbot";
import { EmptyComponent } from "../../../../legacy/components/common/EmptyComponent";
import HeaderV2 from "../../../../legacy/components/HeaderV2/header-v2";
import { SidebarComponent } from "../../../../legacy/components/Sidebar/sidebar-component";
import { SidebarLayoutWrapper } from "../../components/SidebarLayoutWrapper";
import { DefaultLayoutContainer } from "./DefaultLayoutContainer";
import { DefaultLayoutContentContainer } from "./DefaultLayoutContentContainer";
import { DefaultLayoutInnerContainer } from "./DefaultLayoutInnerContainer";

export const DESKTOP_CONTENT_STYLE = {
  maxWidth: "62.125rem",
  margin: "0 auto",
};

export interface DefaultLayoutDesktopProps extends PropsWithChildren<{}> {
  isLogoClickable?: boolean;
}

function DefaultLayoutDesktop({ children, isLogoClickable = true }: Readonly<DefaultLayoutDesktopProps>): JSX.Element {
  const { layoutStyles } = useLayoutStylesStore();
  const { showHeaderStore, showSidebarStore } = useShowLayoutComponentsStore();
  const desktopContentStyling = { ...DESKTOP_CONTENT_STYLE, ...layoutStyles.contentLayoutStyles?.desktop };

  return (
    <DefaultLayoutContainer id={DEFAULT_LAYOUT_ID} sx={layoutStyles.layoutStyles?.desktop}>
      {showSidebarStore ? (
        <SidebarLayoutWrapper>
          <SidebarComponent />
        </SidebarLayoutWrapper>
      ) : (
        <EmptyComponent />
      )}

      <DefaultLayoutInnerContainer>
        {showHeaderStore ? <HeaderV2 isLogoClickable={isLogoClickable} /> : <EmptyComponent />}

        <DefaultLayoutContentContainer
          isMobile={false}
          id={DEFAULT_LAYOUT_CONTENT_ID}
          sx={layoutStyles.contentLayoutStyles?.desktopOuterContainer}
        >
          <Box sx={desktopContentStyling}>{children}</Box>
        </DefaultLayoutContentContainer>
      </DefaultLayoutInnerContainer>

      <Chatbot />
    </DefaultLayoutContainer>
  );
}

export default memo(DefaultLayoutDesktop);
